import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import { registerApp } from '@/global'
import 'normalize.css'
import '@/assets/css/index.less'
import { setupStore } from '@/store'
import 'animate.css/animate.min.css'

import vue3TreeOrg from 'vue3-tree-org'
import 'vue3-tree-org/lib/vue3-tree-org.css'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import '@surely-vue/table/dist/index.less'
import '@surely-vue/table/src/style/antdv.less'
import STable from '@surely-vue/table'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import VueGridLayout from 'vue-grid-layout'

const app = createApp(App)
registerApp(app)
app.use(store)
setupStore()
app.use(router)
app.use(vue3TreeOrg)
app.use(Antd)
app.use(STable)
app.use(VueGridLayout)
app.mount('#app')
